module.exports = __webpack_public_path__ + "static/media/r15.acd60881.png";